var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3499 11.9999C20.3499 16.6115 16.6115 20.3499 11.9999 20.3499C7.38832 20.3499 3.6499 16.6115 3.6499 11.9999C3.6499 7.38832 7.38833 3.6499 11.9999 3.6499C16.6115 3.6499 20.3499 7.38832 20.3499 11.9999ZM11.9999 22.1499C17.6056 22.1499 22.1499 17.6056 22.1499 11.9999C22.1499 6.39421 17.6056 1.8499 11.9999 1.8499C6.39421 1.8499 1.8499 6.39421 1.8499 11.9999C1.8499 17.6056 6.39421 22.1499 11.9999 22.1499ZM13.0008 16.4748C13.0008 15.9225 12.5531 15.4748 12.0008 15.4748L11.9998 15.4748C11.4475 15.4748 10.9998 15.9225 10.9998 16.4748C10.9998 17.0271 11.4475 17.4748 11.9998 17.4748L12.0008 17.4748C12.5531 17.4748 13.0008 17.0271 13.0008 16.4748ZM11.9998 6.62849C12.414 6.62849 12.7498 6.96428 12.7498 7.37849L12.7498 13.055C12.7498 13.4692 12.414 13.805 11.9998 13.805C11.5856 13.805 11.2498 13.4692 11.2498 13.055L11.2498 7.37849C11.2498 6.96428 11.5856 6.62849 11.9998 6.62849Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoError);
export default __webpack_public_path__ + "static/media/info-error.c0b62d4be4e75a2cdcd1dfa17306c804.svg";
export { ForwardRef as ReactComponent };